import { Box, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';

import 'borrower/borrower.scss';

import {
  dashboardRoutePadding,
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { ReceivableDetails } from 'packages/loanProduct/ui/receivablesDashboard/details/ReceivableDetails';

export const PortfolioReceivableDetailsRoute = () => {
  const toast = useToast();
  const history = useHistory();
  const { finleyReceivableId } = useParams<{
    finleyReceivableId: string;
  }>();

  let routeLevelError = false;

  return (
    <Box width="100%" padding={dashboardRoutePadding}>
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            routeLevelError = true;
            toast({
              ...errorToastConfig,
              id: 'errorLoadReceivableDetails',
              title: 'Error loading portfolio receivable details route',
            });
            history.push('/');
          }
        }}
      >
        <ReceivableDetails
          finleyReceivableId={finleyReceivableId}
          isLenderPage
        />
      </Sentry.ErrorBoundary>
    </Box>
  );
};
